module.exports = __webpack_public_path__ + "img/TG.74fe440b.jpg";